export const getSs = (dataName) => {
  let result = sessionStorage.getItem(dataName)
  result = result || null
  return JSON.parse(result)
}

export const setSs = function (dataName, value) {
  sessionStorage.setItem(dataName, JSON.stringify(value))
}

export const removeSs = function (dataName) {
  sessionStorage.removeItem(dataName)
}

export const getLs = (dataName) => {
  let result = localStorage.getItem(dataName)
  result = result || null
  return JSON.parse(result)
}

export const setLs = function (dataName, value) {
  localStorage.setItem(dataName, JSON.stringify(value))
}

export const removeLs = function (dataName) {
  localStorage.removeItem(dataName)
}
